import { useState, useRef, useEffect, useContext} from 'react';
import {ReactComponent as AvatarSVG} from 'assets/icon-avatar.svg';
import {ReactComponent as EditSVG} from 'assets/icon-edit.svg';
import TextField from 'components/TextField';
import DatePicker from 'components/DatePicker';
import styles from './profile.module.scss';
import {useNavigate} from 'react-router-dom';
import {useAuth} from 'context/Auth';
import {getMe, modifyMe} from "../../api/me";
import {GlobalContext4User} from '../../storage/user';
import dayjs from 'dayjs';
// import { format} from 'date-fns';
import { useGlobalError } from 'context/Error/GlobalErrorContext';




export type FormProps = {
  id: number;
  brand_id: number;
  realname: string;
  nickname: string;
  mobile_number: string;
  created_at: string | null;
  line_id: string | null;
  birthday: string | '';
  email: string | null;
  photo_url?: string;
  image?: [
    {
      originFileObj?: Blob;
      uid: number;
      url: string;
      status: string;
      name?: string;
    },
  ];
};
type FormName = 'realname' | 'nickname' | 'birthday' | 'email' | 'photo_url' | 'image';
type FormErrorData = {
  realname?: boolean | string;
  nickname?: boolean | string;
  birthday?: boolean | string;
  email?: boolean | string;
  photo_url?: boolean | string;
};

const Profile = () => {
  const {accessToken, me} = useAuth(); 
  // @ts-ignore // 22.04.19 SCH
  const {meUserStorage} = useContext(GlobalContext4User);
  const {user, setUser} = meUserStorage;
  const navigate = useNavigate();
  const [formData, setFormData] = useState<FormProps>({
    id: 0,
    brand_id: 0,
    realname: '',
    nickname: '',
    mobile_number: '',
    created_at: null,
    line_id: null,
    birthday: '',
    email: null,
    photo_url: '',
    image: [
      {
        originFileObj: new Blob(),
        uid: 0,
        url: '',
        status: '',
        name: '',
      },
    ],
  });
  // eslint-disable-next-line
  const [formError, setFormError] = useState<FormErrorData>({
    realname: false,
    nickname: false,
    birthday: false,
    email: false,
    photo_url: false,
  });

  const [newError, setNewError] = useState<any>({
    realname: false,
    nickname: false,
    birthday: false,
    email: false,
    photo_url: false,
  });
  
  const ref_first = useRef<boolean>(true); // 22.04.19 SCH
  const [disable, setDisable] = useState<boolean>(false); // 22.07.07 SCH
  const [cancel, setCancel] = useState<string>('取消'); // 22.07.07 SCH
  const [imgUrl, setImgUrl] = useState<string>(''); // 22.07.07 SCH
  const imgPreUrl = 'https://packageplusmainsys.s3-ap-northeast-1.amazonaws.com/';
  const { showError } = useGlobalError();


  const onFormChange = async (name: FormName, value: any) => {
    const tmp: FormProps = {...formData};
    if (name === 'birthday') { // 22.07.07 SCH
      tmp[name] = dayjs(value).format('YYYY-MM-DD');
      setFormData(tmp);
      validateForm(name, dayjs(value).format('YYYY-MM-DD'));
    } else {
      tmp[name] = value;
      // console.log("onFormChange", name, " : ", value); // 22.04.19 SCH
      setFormData(tmp);
      validateForm(name, value);
    }
  };

  const handleInput = (e: any) => {
    localStorage.setItem(e.target.name, e.target.value);
  };


  const handleDateInput = (value: any) => {
    // console.log("handleDateInput", "birthday", " : ", dateFormat(value, 'yyyy-MM-dd'));
    // 要在 saveMe() 時才能執行 setUser() // 22.04.21 SCH
    const transT = dayjs(value).format('YYYY-MM-DD')
    // console.log(transT)
    // setUser({...user, "birthday": dateFormat(value, 'yyyy-MM-dd')});
    // localStorage.setItem("birthday", dateFormat(value, 'yyyy-MM-dd'));
    setUser({...user, birthday: transT});
    localStorage.setItem("birthday", transT);
  };


  const validateForm = (name: FormName, value: any) => {
    switch (name) {
      case 'realname':
        if (value === '' || !value) {
          setFormError((prevState) => ({...prevState, realname: '請輸入真實姓名'}));
          return false;
        }
        setFormError((prevState) => ({...prevState, realname: false}));
        return true;
      case 'nickname':
        if (value === '' || !value) {
          setFormError((prevState) => ({...prevState, nickname: '請輸入匿稱'}));
          return false;
        }
        setFormError((prevState) => ({...prevState, nickname: false}));
        return true;
      case 'birthday':
        if (value === '' || !value ) {
          setFormError((prevState) => ({...prevState, birthday: '請輸入生日'}));
          return false;
        }
        setFormError((prevState) => ({...prevState, birthday: false}));
        return true;
      case 'email':
        if (value === '' || !value) {
          setFormError((prevState) => ({...prevState, email: '請輸入E-mail'}));
          return false;
        }
        setFormError((prevState) => ({...prevState, email: false}));
        return true;
      default:
        return true;
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchMe = async () => {
    try {
      await getMe(accessToken!).then(resp => {
            if(resp.data){
              setFormData({
                ...formData,
                realname: resp.data.realname,
                nickname: resp?.data?.nickname!,
                birthday: resp?.data?.birthday!,
                email: resp?.data?.email!, 
                photo_url: resp?.data?.photo_url!,
              })
            }
            
            if (user.photo_url && user.photo_url.length > 9) {
              if (user.photo_url.indexOf('http') < 0) {
                setImgUrl(imgPreUrl + user.photo_url);
              } else {
                setImgUrl(user.photo_url);
              }
            }
          }
      );
    } catch (e: any) {
      console.log(e)
      showError(e, 'error')
    }
  }

  useEffect(() => {
    if (ref_first.current) {
      ref_first.current = false;
      fetchMe();
    }
    return (() => {
      // console.log(`Before Update: State ${user.realname}`);
    })
  }, [fetchMe]);
  
  const saveMe = async (formData: FormProps) => {
    console.log(formData.birthday)
    
    const name_reg = /[^a-zA-Z0-9\u4e00-\u9fa5]/
    const fn_realname_reg = name_reg.test(formData.realname)
    const fn_nickname_reg = name_reg.test(formData.nickname)

    if(formData.realname === '' || !formData.realname || fn_realname_reg || formData.realname.length > 20 ||
    formData.nickname === '' || !formData.nickname || fn_nickname_reg || formData.nickname.length > 20 ||
    formData.email === '' || !formData.email || formData.email.length > 100 ||
    formData.birthday === '' || !formData.birthday ||
    formData.birthday === null
    ){
      setNewError(
        {...newError,
          realname: formData.realname === '' || !formData.realname || fn_realname_reg ? true : false,
          nickname: formData.nickname === '' || !formData.nickname || fn_nickname_reg ? true : false,
          email: formData.email === '' || !formData.email ? true : false,
          birthday: formData.birthday === '' || !formData.birthday || formData.birthday ===null ? true : false,
        });
        
        if(formData.realname === ''){showError('請輸入真實姓名', 'warning'); return}
        if(formData.realname.length > 20){showError('姓名請勿超過20字元', 'warning'); return}
        if(formData.nickname.length > 20){showError('暱稱請勿超過20字元', 'warning'); return}
        if(fn_realname_reg || fn_nickname_reg){showError('請勿輸入特殊符號', 'warning'); return}
        if(formData.nickname === ''){showError('請輸入暱稱', 'warning'); return}
        if(formData.email === ''){showError('請輸入email', 'warning'); return}
        if(formData.email && formData.email.length > 100){showError('email請勿超過100字元', 'warning'); return}
      
      return
    }else{
      setNewError({...newError,
        realname: false,
        nickname:false,
        birthday:false,
        email:false});
    }
    


    try {
      if (formData) {
        let image: string | Blob;
        if (formData.image && formData.image.length > 0) {
          const formImage = formData.image[0] as {
            url: string;
            originFileObj: Blob;
            status: string;
          };
          if (formImage) {
            if (formImage.originFileObj && formImage.status === 'done') {
              image = formImage.originFileObj;
            }
          }
          
          image = selectedFile!;
        }
        const tmpFormData = {...formData};

        const postFormData = new FormData()
        Object.keys(tmpFormData).forEach((key) => {
          if (key === 'image') {
            if (image) {
              postFormData.append(key, image)
            } else if (formData.image && formData.image?.length <= 0) {
              // postFormData.append('reset_image', '1');
            }
          } else {
            postFormData.append(key, `${tmpFormData[key]}`)
          }
        });

        postFormData.append('_method', 'PATCH')
        const { data: resp } = await modifyMe(accessToken!, postFormData);
        if (resp) {
          const { data } = resp
          if (data.message === 'Successfully updated.') {
            formData.photo_url = data.photo_url
            formData.mobile_number = data.data.mobile_number;
            setUser(formData)
            showError('更新成功', 'success')
            setCancel('返回') 
            setDisable(true)
          } else {
            showError('更新失敗，請重試', 'error')
          }
        }else{
            showError('更新失敗，請重試', 'error')
        }
      }
    } catch (e: any) {
      console.log(e)
      showError(e, 'error')
    }
  }

  const [selectedFile, setSelectedFile] = useState(null);
  // eslint-disable-next-line
  const handleFileInput = (e: any) => {
    setSelectedFile(e.target.files[0]);
  }
  
  return (
    <div className={styles.profile}>
      <div className={styles.avatar}>
        { imgUrl.length <= 9 ? <AvatarSVG /> : <img src={ imgUrl } height="80" alt="" /> }
        <EditSVG className={styles.edit} />
        <div style={{textAlign:"center", lineHeight: '30px'}}>
          <h3>{me?.mobile_number}</h3>
        </div>
      </div>
      {/* <div style={{fontSize:"15px"}}>
        <input type="file" onChange={handleFileInput}/>
      </div> */}
      <div className={styles.formContainer} id='myContainer'>
        <div className={styles.inner}>
          <TextField
            required
            id="realName"
            label="真實姓名"
            name="realname"
            error={newError.realname}
            defaultValue={ user.realname }
            onChange={(event) =>
              {
                onFormChange('realname', event.target.value)
                handleInput(event)
              }
            }
          />
          <TextField
            id="nickName"
            label="暱稱"
            name="nickname"
            error={newError.nickname}
            defaultValue={ user.nickname }
            onChange={(event) =>
              {
                onFormChange('nickname', event.target.value)
                handleInput(event)
              }
            }
          />
          <DatePicker
              label="生日"
              renderInput={(props:any) => <TextField {...props}   variant="standard" />}
              value={user.birthday?dayjs(user.birthday):null}
              error={newError.birthday}
              onChange={(newValue:any) =>
                {
                  onFormChange('birthday', newValue)
                  handleDateInput(newValue)
                }
              }
          />
          <TextField
            id="email"
            type="email"
            label="E-mail"
            name="email"
            error={newError.email}
            defaultValue={ user.email }
            onChange={(event) =>
              {
                 onFormChange('email', event.target.value)
                 handleInput(event)
              }
            }
          />
        </div>
        <div className={styles.footer}>
          <button className={styles.save}
            onClick={() => {
              saveMe(formData);
            }}
          disabled={disable}>
            儲存
          </button>
          <button
            id="cancelButton"
            className={styles.cancel}
            onClick={() => {
              navigate('/member');
            }}
          >
            { cancel }
          </button>
        </div>
      </div>
     </div>
  );
};
export default Profile;
